import { render } from "./LowerHelpersButton.vue?vue&type=template&id=3c018b52&scoped=true"
import script from "./LowerHelpersButton.vue?vue&type=script&lang=js"
export * from "./LowerHelpersButton.vue?vue&type=script&lang=js"

import "./LowerHelpersButton.vue?vue&type=style&index=0&id=3c018b52&scoped=true&lang=scss"

import exportComponent from "D:\\tachyon\\Projects\\NowMedia\\tool_cases\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c018b52"]])

export default __exports__